<template>
  <v-container fluid>
    <v-card>
      <v-toolbar dense style="background:#F5F5F5">
        <v-toolbar-title dense style="color:#607D8B;font-weight:bold">Liste des messages employés</v-toolbar-title>
        <v-spacer></v-spacer>
        <v-btn @click="refresh" icon>
          <v-icon color="#009688" large>mdi-refresh</v-icon>
          <template v-slot:loader>
            <span class="custom-loader"> <v-icon light>cached</v-icon></span>
          </template>
        </v-btn>
      </v-toolbar>
      <v-card-text>
        <v-dialog fullscreen v-model="loading">
          <v-container fill-height fluid style="background-color: rgba(200, 200, 200, 0.5);">
            <v-layout align-center="true" justify-center="true">
              <v-progress-circular
                  :on-cancel="onCancel"
                  :size="70"
                  color="#009688"
                  indeterminate>
              </v-progress-circular>
            </v-layout>
          </v-container>
        </v-dialog>

        <!-- Alerte pour les notifications -->
        <v-alert :color="AlertColor(type)"
                 :dismissible="true"
                 :value="true"
                 @input="dismissible_close"
                 border="top"
                 class="pre-formatted multi-line"
                 colored-border
                 elevation="2"
                 icon="check_circle"
                 style="color: #546E7A"
                 v-if="type">
          {{ text }}
        </v-alert>

        <!-- Modal de modification -->
        <modal :adaptive="true"
               :clickToClose="false"
               :draggable="false"
               :resizable="false"
               :height="modalHeight"
               :width="modalWidth"
               name="modal-fade">
          <v-card style="height: 100%; display: flex; flex-direction: column;">

            <!-- ✅ HEADER MINCE - SEULEMENT 60PX -->
            <div style="height: 60px; background: #01579B; display: flex; align-items: center; padding: 0 16px; flex-shrink: 0;">
      <span style="color: white; font-size: 16px; font-weight: 500; flex: 1;">
        {{ modifier }}
      </span>
              <v-btn @click="hide()" icon small dark>
                <v-icon>mdi-close</v-icon>
              </v-btn>
            </div>

            <!-- ✅ CONTENU PRINCIPAL - PREND TOUT L'ESPACE RESTANT -->
            <div style="flex: 1; overflow-y: auto; background: #f5f5f5; padding: 20px;">

              <!-- Alerte -->
              <v-alert
                  v-if="typeS"
                  :color="AlertColorS(typeS)"
                  :type="typeS === 'info' ? 'success' : 'error'"
                  dense
                  dismissible
                  @input="typeS = null"
                  class="mb-4">
                {{ text }}
              </v-alert>

              <!-- Formulaire dans carte blanche -->
              <v-card style="padding: 24px;">
                <v-form>

                  <!-- Informations de l'employé -->
                  <div style="margin-bottom: 32px;">
                    <div style="display: flex; align-items: center; margin-bottom: 16px; border-bottom: 2px solid #e3f2fd; padding-bottom: 8px;">
                      <v-icon color="#01579B" style="margin-right: 8px;">mdi-account</v-icon>
                      <h3 style="color: #01579B; margin: 0; font-size: 18px; font-weight: 600;">
                        Informations de l'employé
                      </h3>
                    </div>

                    <v-row>
                      <v-col cols="12" sm="6">
                        <v-text-field
                            outlined
                            dense
                            label="Matricule"
                            v-model="editedItem.matricule"
                            readonly
                            prepend-inner-icon="mdi-badge-account-horizontal">
                        </v-text-field>
                      </v-col>
                      <v-col cols="12" sm="6">
                        <v-text-field
                            outlined
                            dense
                            label="Identifiant carte"
                            v-model="editedItem.identifiantCarte"
                            readonly
                            prepend-inner-icon="mdi-credit-card"
                            :placeholder="editedItem.identifiantCarte || 'Aucune carte associée'">
                        </v-text-field>
                      </v-col>
                    </v-row>
                  </div>

                  <!-- Contenu du message -->
                  <div style="margin-bottom: 32px;">
                    <div style="display: flex; align-items: center; margin-bottom: 16px; border-bottom: 2px solid #e3f2fd; padding-bottom: 8px;">
                      <v-icon color="#01579B" style="margin-right: 8px;">mdi-message-text</v-icon>
                      <h3 style="color: #01579B; margin: 0; font-size: 18px; font-weight: 600;">
                        Contenu du message
                      </h3>
                    </div>

                    <v-textarea
                        outlined
                        label="Message"
                        rows="4"
                        v-model="editedItem.message"
                        prepend-inner-icon="mdi-message-text"
                        counter="500"
                        :rules="[v => !!v || 'Le message est requis']">
                    </v-textarea>
                  </div>

                  <!-- Paramètres du message -->
                  <div style="margin-bottom: 32px;">
                    <div style="display: flex; align-items: center; margin-bottom: 16px; border-bottom: 2px solid #e3f2fd; padding-bottom: 8px;">
                      <v-icon color="#01579B" style="margin-right: 8px;">mdi-cog</v-icon>
                      <h3 style="color: #01579B; margin: 0; font-size: 18px; font-weight: 600;">
                        Paramètres du message
                      </h3>
                    </div>

                    <v-row>
                      <v-col cols="12" sm="6">
                        <v-select
                            outlined
                            dense
                            label="Priorité"
                            :items="priorities"
                            item-text="text"
                            item-value="value"
                            v-model="editedItem.priorite"
                            prepend-inner-icon="mdi-flag">
                        </v-select>
                      </v-col>
                      <v-col cols="12" sm="6">
                        <v-text-field
                            outlined
                            dense
                            label="Type"
                            v-model="editedItem.type"
                            prepend-inner-icon="mdi-tag">
                        </v-text-field>
                      </v-col>
                    </v-row>
                  </div>

                  <!-- Alerte validation dates -->
                  <v-alert
                      v-if="!isDateRangeValid() && editedItem.dateActivation && editedItem.dateExpiration"
                      type="error"
                      dense
                      class="mb-4">
                    <v-icon left>mdi-alert</v-icon>
                    La date d'expiration doit être postérieure à la date d'activation
                  </v-alert>

                  <!-- Planification -->
                  <div style="margin-bottom: 16px;">
                    <div style="display: flex; align-items: center; margin-bottom: 16px; border-bottom: 2px solid #e3f2fd; padding-bottom: 8px;">
                      <v-icon color="#01579B" style="margin-right: 8px;">mdi-calendar-clock</v-icon>
                      <h3 style="color: #01579B; margin: 0; font-size: 18px; font-weight: 600;">
                        Planification
                      </h3>
                    </div>

                    <v-row>
                      <v-col cols="12" sm="6">
                        <v-text-field
                            outlined
                            dense
                            label="Date d'activation"
                            type="date"
                            v-model="editedItem.dateActivation"
                            prepend-inner-icon="mdi-calendar-check"
                            :rules="dateActivationRules"
                            hint="Heure automatique: 00:00:00"
                            persistent-hint>
                        </v-text-field>
                      </v-col>
                      <v-col cols="12" sm="6">
                        <v-text-field
                            outlined
                            dense
                            label="Date d'expiration"
                            type="date"
                            v-model="editedItem.dateExpiration"
                            prepend-inner-icon="mdi-calendar-remove"
                            :rules="dateExpirationRules"
                            :error-messages="getDateValidationMessage()"
                            hint="Heure automatique: 23:59:59"
                            persistent-hint>
                        </v-text-field>
                      </v-col>
                    </v-row>
                  </div>

                </v-form>
              </v-card>
            </div>

            <!-- ✅ FOOTER MINCE - SEULEMENT 70PX -->
            <div style="height: 70px; background: white; border-top: 1px solid #e0e0e0; display: flex; align-items: center; justify-content: flex-end; padding: 0 24px; gap: 16px; flex-shrink: 0;">
              <v-btn @click="hide()" text color="grey darken-1">
                <v-icon left small>mdi-close</v-icon>
                Annuler
              </v-btn>
              <v-btn
                  :disabled="!FormIsValidModif"
                  @click="updateEmployeeMessage()"
                  color="#01579B"
                  dark>
                <v-icon left small>mdi-content-save</v-icon>
                Modifier
              </v-btn>
            </div>

          </v-card>
        </modal>

        <v-card class="mt-1" flat tile>
          <v-row>
            <v-col v-if="isMobile===false">
              <v-spacer></v-spacer>
            </v-col>
            <v-col>
              <v-text-field :id="dynamicID()"
                            @change="search"
                            @keyup.native.enter="search"
                            @click:clear="cleared()"
                            append-icon="mdi-magnify"
                            class="centered-input align-center"
                            clearable
                            hide-details
                            placeholder="Recherche"
                            v-model="searchName">
              </v-text-field>
            </v-col>
            <v-col>
              <v-btn @click="onexport" block class="custom-btn white--text" color="#00BCD4" height="45px" large>
                <v-icon class="mr-1">mdi-file-excel-outline</v-icon>
                <span>Export messages</span>
              </v-btn>
            </v-col>
            <v-col>
              <v-dialog max-width="800px" persistent v-model="dialog">
                <template v-slot:activator="{ on }">
                  <v-btn @click="init()" block class="custom-btn white--text" color="#009688" height="45px" large
                         v-on="on">
                    <v-icon class="mr-1">mdi-plus-circle-outline</v-icon>
                    <span>Ajouter message</span>
                  </v-btn>
                </template>
                <v-card>
                  <v-toolbar
                      color="#01579B"
                      dark
                      flat>
                    <v-toolbar-title>Nouveau message employé</v-toolbar-title>
                    <v-spacer></v-spacer>
                    <v-btn
                        @click="close"
                        dark
                        fab
                        small>
                      <v-icon>mdi-close</v-icon>
                    </v-btn>
                  </v-toolbar>
                  <v-card-text>
                    <v-container class="pa-6">
                      <v-form>
                        <!-- Sélection de l'employé -->
                        <v-row class="mb-4">
                          <v-col cols="12">
                            <h3 class="subtitle-1 font-weight-bold text--primary mb-3">
                              <v-icon color="primary" class="mr-2">mdi-account-search</v-icon>
                              Sélection de l'employé
                            </h3>
                          </v-col>
                          <v-col cols="12">
                            <v-autocomplete :id="dynamicID()"
                                            outlined
                                            dense
                                            label="Sélectionner un employé"
                                            :items="employees"
                                            item-text="displayText"
                                            item-value="matricule"
                                            v-model="editedItem.matricule"
                                            @change="onEmployeeSelected"
                                            :loading="loadingEmployees"
                                            clearable
                                            prepend-inner-icon="mdi-magnify"
                                            placeholder="Rechercher par matricule ou nom">
                            </v-autocomplete>
                          </v-col>
                        </v-row>

                        <!-- Informations de l'employé sélectionné -->
                        <v-row v-if="editedItem.matricule" class="mb-4">
                          <v-col cols="12">
                            <h3 class="subtitle-1 font-weight-bold text--primary mb-3">
                              <v-icon color="primary" class="mr-2">mdi-account</v-icon>
                              Informations de l'employé
                            </h3>
                          </v-col>
                          <v-col cols="12" md="6">
                            <v-text-field :id="dynamicID()"
                                          outlined
                                          dense
                                          label="Matricule"
                                          v-model="editedItem.matricule"
                                          readonly
                                          prepend-inner-icon="mdi-badge-account-horizontal"></v-text-field>
                          </v-col>
                          <v-col cols="12" md="6">
                            <v-text-field :id="dynamicID()"
                                          outlined
                                          dense
                                          label="Identifiant carte"
                                          v-model="editedItem.identifiantCarte"
                                          readonly
                                          prepend-inner-icon="mdi-credit-card"
                                          :placeholder="editedItem.identifiantCarte || 'Aucune carte associée'"></v-text-field>
                          </v-col>
                        </v-row>

                        <!-- Contenu du message -->
                        <v-row class="mb-4">
                          <v-col cols="12">
                            <h3 class="subtitle-1 font-weight-bold text--primary mb-3">
                              <v-icon color="primary" class="mr-2">mdi-message-text</v-icon>
                              Contenu du message
                            </h3>
                          </v-col>
                          <v-col cols="12">
                            <v-textarea :id="dynamicID()"
                                        outlined
                                        label="Message"
                                        rows="4"
                                        v-model="editedItem.message"
                                        prepend-inner-icon="mdi-message-text"
                                        counter="500"
                                        :rules="[v => !!v || 'Le message est requis']"></v-textarea>
                          </v-col>
                        </v-row>

                        <!-- Paramètres du message -->
                        <v-row class="mb-4">
                          <v-col cols="12">
                            <h3 class="subtitle-1 font-weight-bold text--primary mb-3">
                              <v-icon color="primary" class="mr-2">mdi-cog</v-icon>
                              Paramètres du message
                            </h3>
                          </v-col>
                          <v-col cols="12" md="6">
                            <v-select :id="dynamicID()"
                                      outlined
                                      dense
                                      label="Priorité"
                                      :items="priorities"
                                      item-text="text"
                                      item-value="value"
                                      v-model="editedItem.priorite"
                                      prepend-inner-icon="mdi-flag"></v-select>
                          </v-col>
                          <v-col cols="12" md="6">
                            <v-text-field :id="dynamicID()"
                                          outlined
                                          dense
                                          label="Type"
                                          v-model="editedItem.type"
                                          prepend-inner-icon="mdi-tag"></v-text-field>
                          </v-col>
                        </v-row>

                        <!-- Add this alert above your date fields -->
                        <v-alert
                            v-if="!isDateRangeValid() && editedItem.dateActivation && editedItem.dateExpiration"
                            type="error"
                            dense
                            class="mb-3">
                          <v-icon left>mdi-alert</v-icon>
                          La date d'expiration doit être postérieure à la date d'activation
                        </v-alert>

                        <!-- Planification -->
                        <v-row class="mb-4">
                          <v-col cols="12">
                            <h3 class="subtitle-1 font-weight-bold text--primary mb-3">
                              <v-icon color="primary" class="mr-2">mdi-calendar-clock</v-icon>
                              Planification
                            </h3>
                          </v-col>
                          <v-col cols="12" md="6">
                            <v-text-field
                                :id="dynamicID()"
                                outlined
                                dense
                                label="Date d'activation"
                                type="date"
                                v-model="editedItem.dateActivation"
                                prepend-inner-icon="mdi-calendar-check"
                                :rules="dateActivationRules">
                            </v-text-field>

                          </v-col>
                          <v-col cols="12" md="6">
                            <v-text-field
                                :id="dynamicID()"
                                outlined
                                dense
                                label="Date d'expiration"
                                type="date"
                                v-model="editedItem.dateExpiration"
                                prepend-inner-icon="mdi-calendar-remove"
                                :rules="dateExpirationRules"
                                :error-messages="getDateValidationMessage()">
                            </v-text-field>
                          </v-col>
                        </v-row>
                      </v-form>
                    </v-container>
                  </v-card-text>
                  <v-divider></v-divider>
                  <v-card-actions class="pa-4">
                    <v-spacer></v-spacer>
                    <v-btn
                        @click="close"
                        outlined
                        color="grey darken-1"
                        class="mr-3"
                        min-width="120">
                      <v-icon left>mdi-close</v-icon>
                      Annuler
                    </v-btn>
                    <v-btn
                        :disabled="!FormIsValid"
                        @click="createEmployeeMessage()"
                        color="#01579B"
                        dark
                        min-width="120">
                      <v-icon left>mdi-plus</v-icon>
                      Créer
                    </v-btn>
                  </v-card-actions>
                </v-card>
              </v-dialog>
            </v-col>
          </v-row>
        </v-card>

        <v-card class="mt-4" elevation="6">
          <hot-table :settings="hotSettings" ref="hotTable"></hot-table>
        </v-card>
      </v-card-text>
    </v-card>
  </v-container>
</template>

<script>
import {HotTable} from "@handsontable/vue";
import "handsontable/languages/fr-FR";
import apiClient from "../../../config/api.js";
import moment from "moment";
import "moment/locale/fr";
import "vue-loading-overlay/dist/vue-loading.css";
import * as XLSX from 'xlsx';

function isMobileDevice() {
  return /Mobi|Android/i.test(navigator.userAgent);
}

export default {
  name: "employee_messages",
  components: {HotTable},
  data: function () {
    return {
      originalMessages: [], // Store original API response
      dateActivationRules: [
        v => {
          if (!v) return true; // Champ optionnel

          // Format YYYY-MM-DD (input date)
          const date = moment(v, "YYYY-MM-DD");
          return date.isValid() || 'Date d\'activation invalide';
        }
      ],

      dateExpirationRules: [
        v => {
          if (!v) return true; // Champ optionnel

          // Format YYYY-MM-DD (input date)
          const date = moment(v, "YYYY-MM-DD");
          if (!date.isValid()) return 'Date d\'expiration invalide';

          // Vérifier si l'expiration est après l'activation
          if (this.editedItem.dateActivation) {
            const activationDate = moment(this.editedItem.dateActivation, "YYYY-MM-DD");
            return date.isSameOrAfter(activationDate) || 'La date d\'expiration doit être postérieure à la date d\'activation';
          }

          return true;
        }
      ],
      isMobile: isMobileDevice(),
      disableMainBtn: false,
      searchName: "",
      lastHighlitedRow: null,
      loading: false,
      loadingEmployees: false,
      loading2: false,
      e6: 1,
      tab: null,
      dialog: false,
      alert: false,
      fullPage: false,
      text: "",
      color: "",
      file: "",
      editedIndex: -1,
      modifier: "",
      typeS: null,
      type: null,
      elapse: null,
      errors: [],
      excelData: [],
      toObject: [],
      employees: [],
      priorities: [
        {text: 'Faible', value: 'low'},
        {text: 'Moyenne', value: 'medium'},
        {text: 'Élevée', value: 'high'}
      ],
      editedItem: {
        id: "",
        matricule: "",
        identifiantCarte: "",
        message: "",
        priorite: "medium",
        type: "",
        dateActivation: "",
        dateExpiration: "",
        dateCreation: ""
      },
      hotSettings: {
        locale: "fr-FR",
        dateFormat: "DD/MM/YYYY HH:mm:ss",
        correctFormat: true,
        ariaTags: false, // Disable problematic ARIA tags
        tabMoves: {row: 1, col: 0}, // Better keyboard navigation
        enterMoves: {row: 1, col: 0}, // Better keyboard navigation
        renderAllRows: false,
        viewportRowRenderingOffset: 'auto',
        data: [],
        colWidths: 100,
        width: "100%",
        height: "675px",
        fixedRowsTop: 0,
        columnSorting: true,
        sortIndicator: true,
        filters: true,
        selectionMode: "single",
        dropdownMenu: ["filter_by_condition", "filter_action_bar", "filter_operators", "filter_by_value"],
        licenseKey: "non-commercial-and-evaluation",
        stretchH: "all",
        minSpareRows: false,
        language: "fr-FR",
        customBorders: true,
        columnHeaders: true,
        rowHeaders: true,
        stretch: "all",
        readOnly: false,
        contextMenu: {
          items: {
            modifier: {
              name: "Modifier",
              callback: (key, selection, clickEvent) => {
                setTimeout(() => {
                  let start = selection[0].start;
                  this.displayTitleModif(start.row);
                  this.updateData4Modif(start.row);
                  this.show();
                }, 0);
              }
            },
            activate: {
              name: "Activer",
              callback: (key, selection, clickEvent) => {
                setTimeout(() => {
                  let start = selection[0].start;
                  this.activateMessage(start.row);
                }, 0);
              }
            },
            deactivate: {
              name: "Désactiver",
              callback: (key, selection, clickEvent) => {
                setTimeout(() => {
                  let start = selection[0].start;
                  this.deactivateMessage(start.row);
                }, 0);
              }
            },
            remove_row: {
              name: "Supprimer",
              callback: (key, selection, clickEvent) => {
                setTimeout(() => {
                  let start = selection[0].start;
                  this.beforeRemoveRowMe(start.row, 1);
                }, 0);
              }
            }
          }
        },
        afterSelection: function(row, column, row2, column2) {
          // Remove problematic aria-hidden attributes
          const inputs = document.querySelectorAll('.handsontableInput[aria-hidden="true"]');
          inputs.forEach(input => {
            if (input === document.activeElement) {
              input.removeAttribute('aria-hidden');
            }
          });
        },
        beforeChange: function(changes, source) {
          console.log("beforeChange - Source:", source, "Changes:", changes);

          if (changes && source === 'edit') {
            changes.forEach(function(change) {
              let [row, prop, oldValue, newValue] = change;

              console.log("beforeChange - Row:", row, "Prop:", prop, "Old:", oldValue, "New:", newValue);

              // Si c'est une colonne de date (index 6 ou 7)
              if ((prop === 6 || prop === 7) && newValue && typeof newValue === 'string') {

                // Si c'est au format MM/DD/YYYY, convertir en DD/MM/YYYY
                if (newValue.match(/^\d{2}\/\d{2}\/\d{4}$/)) {
                  const parts = newValue.split('/');
                  const part1 = parseInt(parts[0]);
                  const part2 = parseInt(parts[1]);
                  const year = parts[2];

                  // Si le premier nombre > 12, c'est forcément un jour → format DD/MM/YYYY
                  if (part1 > 12) {
                    console.log("Format détecté: DD/MM/YYYY (jour > 12)");
                    // Garder tel quel
                  }
                  // Si le deuxième nombre > 12, c'est forcément un mois → format MM/DD/YYYY
                  else if (part2 > 12) {
                    console.log("Format détecté: MM/DD/YYYY (mois > 12) - Conversion nécessaire");
                    change[3] = `${parts[1]}/${parts[0]}/${year}`;
                    console.log("Converti en:", change[3]);
                  }
                  // Cas ambigu (les deux <= 12) - supposer format américain et convertir
                  else {
                    console.log("Format ambigu - Supposer DD/MM/YYYY et garder tel quel");
                  }
                }
              }
            });
          }
        },
        afterInit: function() {
          console.log("Handsontable initialized with French locale");
          moment.locale('fr');
        },
        // Ajoutez ceci dans hotSettings
        beforeEdit: function(row, col, prop, td, originalValue) {
          console.log("beforeEdit - Row:", row, "Col:", col, "Original:", originalValue);

          // Si c'est une colonne de date et que la cellule est vide
          if ((col === 6 || col === 7) && (!originalValue || originalValue === '')) {
            // Définir la date d'aujourd'hui comme valeur par défaut
            const today = moment().format('DD/MM/YYYY');
            console.log("beforeEdit - Setting default date:", today);
            this.setDataAtCell(row, col, today, 'edit');
            return false; // Empêcher l'édition normale
          }
        },
        afterChange: this.afterChangeMe,
        beforeRemoveRow: this.beforeRemoveRowMe,
        afterFilter: this.afterFilter,
        afterLoadData: this.afterLoadData,
        currentRowClassName: 'rowHighlight',
        manualColumnResize: true,
        className: "htCenter htMiddle",
        hiddenColumns: {
          columns: [0, 8, 9],
          indicators: false
        },
        colHeaders: [
          "Id", "Matricule", "Identifiant Carte", "Message", "Priorité", "Type", "Date Activation", "Date Expiration", "Actif", "Désactivé", "Date Création"
        ],
        columns: [
          {title: "Id", width: "60px", readOnly: true},
          {title: "Matricule", width: "100px", readOnly: true},
          {title: "Identifiant Carte", width: "120px", readOnly: true},
          {title: "Message", width: "200px", readOnly: false},
          {title: "Priorité", width: "80px", readOnly: false, type: "dropdown", source: ['low', 'medium', 'high']},
          {title: "Type", width: "100px", readOnly: false},
          // ✅ Configuration sans defaultDate
          {
            title: "Date Activation",
            width: "120px",
            readOnly: false,
            type: "date",
            dateFormat: "DD/MM/YYYY",
            correctFormat: true,
            datePickerConfig: {
              firstDay: 1, // Lundi comme premier jour
              showWeekNumber: true,
              format: 'dd/mm/yyyy',
              toString: function (date, format) {
                // Forcer le format français pour l'affichage
                return moment(date).format('DD/MM/YYYY');
              },
              parse: function (dateString, format) {
                // Parser en format français
                const date = moment(dateString, 'DD/MM/YYYY');
                return date.isValid() ? date.toDate() : new Date(NaN);
              },
              i18n: {
                previousMonth: 'Mois précédent',
                nextMonth: 'Mois suivant',
                months: ['Janvier', 'Février', 'Mars', 'Avril', 'Mai', 'Juin', 'Juillet', 'Août', 'Septembre', 'Octobre', 'Novembre', 'Décembre'],
                weekdays: ['Dimanche', 'Lundi', 'Mardi', 'Mercredi', 'Jeudi', 'Vendredi', 'Samedi'],
                weekdaysShort: ['Dim', 'Lun', 'Mar', 'Mer', 'Jeu', 'Ven', 'Sam']
              }
            },
          },
          {
            title: "Date Expiration",
            width: "120px",
            readOnly: false,
            type: "date",
            dateFormat: "DD/MM/YYYY",
            correctFormat: true,
            datePickerConfig: {
              firstDay: 1,
              showWeekNumber: true,
              format: 'dd/mm/yyyy',
              toString: function(date, format) {
                return moment(date).format('DD/MM/YYYY');
              },
              parse: function(dateString, format) {
                const date = moment(dateString, 'DD/MM/YYYY');
                return date.isValid() ? date.toDate() : new Date(NaN);
              },
              i18n: {
                previousMonth: 'Mois précédent',
                nextMonth: 'Mois suivant',
                months: ['Janvier', 'Février', 'Mars', 'Avril', 'Mai', 'Juin', 'Juillet', 'Août', 'Septembre', 'Octobre', 'Novembre', 'Décembre'],
                weekdays: ['Dimanche', 'Lundi', 'Mardi', 'Mercredi', 'Jeudi', 'Vendredi', 'Samedi'],
                weekdaysShort: ['Dim', 'Lun', 'Mar', 'Mer', 'Jeu', 'Ven', 'Sam']
              }
            }
          },
          {title: "Actif", width: "60px", readOnly: true, type: "checkbox"},
          {title: "Désactivé", width: "70px", readOnly: true, type: "checkbox"},
          {
            title: "Date Création",
            width: "120px",
            readOnly: true,
            type: "date",
            dateFormat: "DD/MM/YYYY"
          }
        ]
      }
    }
  },

  created() {
    moment.locale('fr');
    this.getData();
  },

  mounted() {
    // Forcer la locale française pour moment.js
    moment.locale('fr');
    console.log("Moment locale set to:", moment.locale());

    // Assignations window
    window.show = this.show;
    window.displayTitleModif = this.displayTitleModif;
    window.updateData4Modif = this.updateData4Modif;

    // Configuration datepicker
    this.$nextTick(() => {
      if (this.$refs.hotTable && this.$refs.hotTable.hotInstance) {
        this.configureDatePicker();
      }
    });

    // Listener resize
    window.addEventListener('resize', this.handleResize);
  },

  beforeDestroy() {
    window.removeEventListener('resize', this.handleResize);
  },

  watch: {
    'editedItem.dateActivation'() {
      this.$nextTick(() => {
        // Force re-validation of expiration date
        if (this.$refs.dateExpirationField) {
          this.$refs.dateExpirationField.validate();
        }
      });
    },
    'editedItem.dateExpiration'() {
      this.$nextTick(() => {
        // Force re-validation
        if (this.$refs.dateExpirationField) {
          this.$refs.dateExpirationField.validate();
        }
      });
    }
  },

  computed: {
    FormIsValid() {
      return (
          this.editedItem.matricule !== "" &&
          this.editedItem.message !== ""
      );
    },
    FormIsValidModif() {
      return (
          this.editedItem.matricule !== "" &&
          this.editedItem.message !== ""
      );
    },
    // ✅ Ajouter ces computed properties
    modalHeight() {
      if (this.isMobile) {
        return Math.floor(window.innerHeight * 0.95);
      }
      return 600;
    },
    modalWidth() {
      if (this.isMobile) {
        return Math.floor(window.innerWidth * 0.95);
      }
      return 800;
    }
  },

  methods: {
    configureDatePicker() {
      // Configurer le datepicker pour afficher le mois actuel par défaut
      const today = new Date();
      if (window.Pikaday) {
        window.Pikaday.defaults = {
          ...window.Pikaday.defaults,
          defaultDate: today,
          setDefaultDate: true
        };
      }
    },

    handleResize() {
      // Forcer la re-calculation des dimensions
      this.$forceUpdate();
    },

    isDateRangeValid() {
      // Si l'une des dates est vide, considérer comme valide
      if (!this.editedItem.dateActivation || !this.editedItem.dateExpiration) {
        return true;
      }

      console.log("isDateRangeValid - Activation:", this.editedItem.dateActivation, "Expiration:", this.editedItem.dateExpiration);

      // Parser les dates selon leur format (YYYY-MM-DD pour les inputs)
      const activationDate = moment(this.editedItem.dateActivation, "YYYY-MM-DD");
      const expirationDate = moment(this.editedItem.dateExpiration, "YYYY-MM-DD");

      console.log("isDateRangeValid - Parsed Activation:", activationDate.format(), "Expiration:", expirationDate.format());

      // La date d'expiration doit être >= à la date d'activation
      const isValid = expirationDate.isSameOrAfter(activationDate);
      console.log("isDateRangeValid - Result:", isValid);

      return isValid;
    },

    getDateValidationMessage() {
      if (!this.isDateRangeValid()) {
        return "La date d'expiration doit être postérieure à la date d'activation";
      }
      return "";
    },

    displayTitleModif(row) {
      let rowT = this.$refs.hotTable.hotInstance.getData()[row];
      this.modifier = "Modification message pour " + rowT[1] + " - " + (rowT[3] || '').substring(0, 30) + "...";
    },

    async getEmployees() {
      this.loadingEmployees = true;
      const company_id = process.env.VUE_APP_APP_COMPANY_ID;

      try {
        const response = await apiClient.get(
            `${this.$store.getters.user.baseUrl}/account/users/company/${company_id}`
        );

        if (response.data.status === 200 && response.data.datas) {
          this.employees = response.data.datas.map(employee => ({
            matricule: employee.userId,
            displayText: `${employee.userId} - ${employee.accountLastname || ''} ${employee.accountFirstname || ''}`.trim(),
            walletCardId: employee.walletCardId,
            fullData: employee
          })).filter(emp => emp.matricule);
        } else {
          this.employees = [];
        }
      } catch (error) {
        console.error("Erreur lors du chargement des employés:", error);
        this.employees = [];

        this.color = "#F44336";
        this.text = "Impossible de charger la liste des employés.";
        this.showAlert('warning');
      } finally {
        this.loadingEmployees = false;
      }
    },

    async onEmployeeSelected(matricule) {
      if (!matricule) {
        this.editedItem.identifiantCarte = "";
        return;
      }

      try {
        const sender_id = sessionStorage.getItem("accountId");

        const employeeResponse = await apiClient.get(
            `${this.$store.getters.user.baseUrl}/account/user_by_matricule/${matricule}/${sender_id}`
        );

        if (employeeResponse.data.status === 200 && employeeResponse.data.datas) {
          const employee = employeeResponse.data.datas;
          this.editedItem.identifiantCarte = employee.walletCardIdentifiant || null;
        } else {
          this.editedItem.identifiantCarte = null;
        }
      } catch (error) {
        console.error("Erreur lors de la récupération de l'employé:", error);
        this.editedItem.identifiantCarte = null;

        this.color = "#F44336";
        this.text = "Erreur lors de la récupération des informations de l'employé";
        this.showAlert('warning');
      }
    },
    updateData4Modif(row) {
      let rowT = this.$refs.hotTable.hotInstance.getData()[row];
      let messageId = rowT[0];

      console.log("updateData4Modif - Row data:", rowT);

      if (!rowT[0] || rowT[0] === "") {
        this.color = "#F44336";
        this.text = "Impossible de modifier le message : ID manquant dans les données retournées par l'API";
        this.showAlert('warning');
        return;
      }

      // Trouver le message original
      let originalMessage = this.originalMessages.find(msg => msg.id === messageId);

      if (originalMessage) {
        console.log("updateData4Modif - Original message:", originalMessage);

        this.editedItem.id = originalMessage.id;
        this.editedItem.matricule = originalMessage.matricule;
        this.editedItem.identifiantCarte = originalMessage.identifiantCarte;
        this.editedItem.message = originalMessage.message;
        this.editedItem.priorite = originalMessage.priorite;
        this.editedItem.type = originalMessage.type;

        // ✅ CORRECTION: Formatage des dates pour les inputs
        this.editedItem.dateActivation = this.formatDateForInput(originalMessage.dateActivation);
        this.editedItem.dateExpiration = this.formatDateForInput(originalMessage.dateExpiration);
        this.editedItem.dateCreation = originalMessage.dateCreation;

        console.log("updateData4Modif - Edited item prepared:", this.editedItem);
      }
    },

    formatDateForServer(dateInput, isExpirationDate = false) {
      if (!dateInput) return null;

      try {
        let date;

        console.log("formatDateForServer - Input:", dateInput, "isExpiration:", isExpirationDate);

        // Si c'est une string au format YYYY-MM-DD (input date)
        if (typeof dateInput === 'string' && dateInput.match(/^\d{4}-\d{2}-\d{2}$/)) {
          date = moment(dateInput, "YYYY-MM-DD");
          console.log("Parsed YYYY-MM-DD:", dateInput, "->", date.format());
        }
        // Si c'est une string au format DD/MM/YYYY (Handsontable)
        else if (typeof dateInput === 'string' && dateInput.match(/^\d{2}\/\d{2}\/\d{4}$/)) {
          const parts = dateInput.split('/');
          const day = parts[0];
          const month = parts[1];
          const year = parts[2];
          date = moment(`${year}-${month}-${day}`, "YYYY-MM-DD");
          console.log("Parsed DD/MM/YYYY:", `${day}/${month}/${year}`, "->", date.format());
        }
        // Si c'est déjà un objet Date
        else if (dateInput instanceof Date) {
          date = moment(dateInput);
          console.log("Parsed Date object:", dateInput, "->", date.format());
        }
        // Autres formats
        else {
          moment.locale('fr');
          date = moment(dateInput);
          console.log("Parsed other format:", dateInput, "->", date.format());
        }

        if (!date.isValid()) {
          console.error("Date invalide:", dateInput);
          return null;
        }

        // ✅ AJOUTER LES HEURES AUTOMATIQUEMENT
        if (isExpirationDate) {
          date.set({ hour: 23, minute: 59, second: 59, millisecond: 0 });
        } else {
          date.set({ hour: 0, minute: 0, second: 0, millisecond: 0 });
        }

        // ✅ RETOURNER AU FORMAT ATTENDU PAR LE BACKEND
        const result = date.format("YYYY-MM-DD HH:mm:ss");
        console.log("formatDateForServer - Output:", result);
        return result;

      } catch (e) {
        console.error("Erreur formatage date pour serveur:", e, dateInput);
        return null;
      }
    },

    formatDateForInput(dateValue) {
      if (!dateValue) return "";

      try {
        console.log("formatDateForInput - Input:", dateValue);

        let date;

        // Si c'est le format backend YYYY-MM-DD HH:mm:ss
        if (typeof dateValue === 'string' && dateValue.match(/^\d{4}-\d{2}-\d{2} \d{2}:\d{2}:\d{2}$/)) {
          date = moment(dateValue, "YYYY-MM-DD HH:mm:ss");
        }
        // Si c'est le format ISO 8601
        else if (typeof dateValue === 'string' && dateValue.match(/^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}/)) {
          date = moment(dateValue);
        }
        // Autres formats
        else {
          moment.locale('fr');
          date = moment(dateValue);
        }

        if (!date.isValid()) {
          console.error("Date invalide pour input:", dateValue);
          return "";
        }

        // ✅ RETOURNER FORMAT YYYY-MM-DD POUR INPUT TYPE="DATE"
        const result = date.format("YYYY-MM-DD");
        console.log("formatDateForInput - Output:", result);
        return result;

      } catch (e) {
        console.error("Date input formatting error:", e, dateValue);
        return "";
      }
    },

    formatDateForDisplay(dateValue) {
      if (!dateValue) return "";

      try {
        console.log("formatDateForDisplay - Input:", dateValue);

        let date;

        // Si c'est le format backend YYYY-MM-DD HH:mm:ss
        if (typeof dateValue === 'string' && dateValue.match(/^\d{4}-\d{2}-\d{2} \d{2}:\d{2}:\d{2}$/)) {
          date = moment(dateValue, "YYYY-MM-DD HH:mm:ss");
        }
        // Si c'est le format ISO 8601
        else if (typeof dateValue === 'string' && dateValue.match(/^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}/)) {
          date = moment(dateValue);
        }
        // Autres formats
        else {
          moment.locale('fr');
          date = moment(dateValue);
        }

        if (!date.isValid()) {
          console.error("Date invalide pour affichage:", dateValue);
          return "Date invalide";
        }

        const result = date.format("DD/MM/YYYY");
        console.log("formatDateForDisplay - Output:", result);
        return result;

      } catch (e) {
        console.error("Date formatting error:", e, dateValue);
        return "";
      }
    },

    isEmpty(str) {
      return (!str || 0 === str.length || /^\s*$/.test(str));
    },

    cleared() {
      this.searchName = "";
      this.getData();
    },

    search() {
      var query = this.isEmpty(this.searchName) ? this.searchName : this.searchName.toLowerCase();

      if (this.isEmpty(query)) {
        this.cleared();
      }

      var row;
      var col;
      var rLen;
      var cLen;
      var data = this.$refs.hotTable.hotInstance.getData();
      var array = [];
      for (row = 0, rLen = data.length; row < rLen; row++) {
        for (col = 0, cLen = Object.keys(data[row]).length; col < cLen; col++) {
          var x = Object.keys(data[row])[col];
          if (('' + data[row][x]).toLowerCase().indexOf(query) > -1) {
            array.push(data[row]);
            break;
          }
        }
      }
      this.$refs.hotTable.hotInstance.loadData(array);
    },

    dynamicID() {
      return 'dynamicID-' + Math.floor(Math.random() * Date.now().toString());
    },

    show() {
      this.$modal.show('modal-fade');
    },

    hide() {
      this.$modal.hide('modal-fade');
    },

    init() {
      this.tab = "tab-1";
      this.file = "";
      this.initEditedItem();
      this.getEmployees();
    },

    initEditedItem() {
      this.editedItem = {
        id: "",
        matricule: "",
        identifiantCarte: "",
        message: "",
        priorite: "medium",
        type: "",
        dateActivation: "",
        dateExpiration: "",
        dateCreation: ""
      };
    },

    afterSelectionEnd(r, c) {
      var i;
      if (this.lastHighlitedRow !== null) {
        for (i = 0; i < this.$refs.hotTable.hotInstance.countCols(); i++) {
          this.$refs.hotTable.hotInstance.setCellMeta(this.lastHighlitedRow, i, 'className', 'htCenter htMiddle');
        }
      }

      for (i = 0; i < this.$refs.hotTable.hotInstance.countCols(); i++) {
        this.$refs.hotTable.hotInstance.setCellMeta(r, i, 'className', 'area highlight, htCenter htMiddle');
      }
      this.lastHighlitedRow = r;

      this.$refs.hotTable.hotInstance.render();
    },

    getData() {
      this.loading = true;
      const company_id = sessionStorage.getItem("companyId") || 1;
      const sender_id = sessionStorage.getItem("accountId");

      apiClient
          .get(
              `${this.$store.getters.user.baseUrl}/wallet/employee_messages/${company_id}/${sender_id}`
          )
          .then(response => {
            console.log("API Response:", response.data); // Debug the full response

            this.loading = false;
            let tabArray = [];

            if (response.data.status !== 200) {
              this.color = "#F44336";
              this.text = response.data.message;
              this.showAlert('warning');
              this.disableMainBtn = true;
            } else {
              this.disableMainBtn = false;
              let messages = response.data.datas.messages || [];
              this.originalMessages = messages; // Store original data

              messages.forEach((item) => {
                console.log("Date fields:", {
                  dateActivation: item["dateActivation"],
                  dateExpiration: item["dateExpiration"]
                });

                tabArray.push([
                  item["id"] || "",
                  item["matricule"] || "",
                  item["identifiantCarte"] || "",
                  item["message"] || "",
                  item["priorite"] || "",
                  item["type"] || "",
                  this.formatDateForDisplay(item["dateActivation"]),    // Display format
                  this.formatDateForDisplay(item["dateExpiration"]),    // Display format
                  item["actif"] || "",
                  item["disabled"] || "",
                  this.formatDateForDisplay(item["dateCreation"]),
                  // Store original timestamps in hidden columns
                  item["dateActivation"] || null,     // Original timestamp (hidden)
                  item["dateExpiration"] || null      // Original timestamp (hidden)
                ]);
              });
            }

            this.$refs.hotTable.hotInstance.loadData(tabArray);
            this.toObject = [this.hotSettings.colHeaders, ...this.$refs.hotTable.hotInstance.getData()];
          })
          .catch((error) => {
            this.loading = false;
            this.color = "#F44336";
            this.text = "Erreur lors du chargement des données";
            this.showAlert('warning');
          });
    },

    onCancel() {
      this.loading = false;
    },

    refresh() {
      this.getData();
    },

    close() {
      this.dialog = false;
      this.initEditedItem();
    },

    AlertColor(type) {
      return type === "info" ? "#4CAF50" : "#F44336";
    },

    showAlert(type) {
      this.type = type;

      let timer = this.showAlert.timer;
      if (timer) {
        clearTimeout(timer);
      }
      this.showAlert.timer = setTimeout(() => {
        this.type = null;
      }, 20000);

      this.elapse = 1;
      let t = this.showAlert.t;
      if (t) {
        clearInterval(t);
      }

      this.showAlert.t = setInterval(() => {
        if (this.elapse === 3) {
          this.elapse = 0;
          clearInterval(this.showAlert.t);
        } else {
          this.elapse++;
        }
      }, 5000);
    },

    AlertColorS(type) {
      return type === "info" ? "#4CAF50" : "#F44336";
    },

    showAlertS(type) {
      this.typeS = type;

      let timer = this.showAlert.timer;
      if (timer) {
        clearTimeout(timer);
      }
      this.showAlert.timer = setTimeout(() => {
        if (this.typeS === "info") {
          this.hide();
        }
        this.typeS = null;
      }, 20000);

      this.elapse = 1;
      let t = this.showAlert.t;
      if (t) {
        clearInterval(t);
      }

      this.showAlert.t = setInterval(() => {
        if (this.elapse === 4) {
          this.elapse = 0;
          clearInterval(this.showAlert.t);
        } else {
          this.elapse++;
        }
      }, 5000);
    },

    dismissible_close() {
      this.elapse = 3;
      clearTimeout(this.showAlert.timer);
      clearInterval(this.showAlert.t);
      this.type = null;
    },

    onexport() {
      this.loading = true;
      var datas = XLSX.utils.json_to_sheet(this.toObject, {skipHeader: true});
      var wb = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(wb, datas, "EmployeeMessages");
      XLSX.writeFile(wb, "EmployeeMessages.xlsx");
      this.loading = false;
    },

    createEmployeeMessage() {
      if (!this.FormIsValid) {
        return;
      }

      this.loading = true;
      const sender_id = sessionStorage.getItem("accountId");
      const company_id = parseInt(sessionStorage.getItem("companyId")) || 1;

      const messageData = {
        companyId: company_id,
        matricule: this.editedItem.matricule,
        identifiantCarte: this.editedItem.identifiantCarte || null,
        message: this.editedItem.message,
        priorite: this.editedItem.priorite.toUpperCase(),
        type: this.editedItem.type || null,
        // ✅ UTILISER LE NOUVEAU FORMAT AVEC HEURES
        dateActivation: this.editedItem.dateActivation ? this.formatDateForServer(this.editedItem.dateActivation, false) : null,
        dateExpiration: this.editedItem.dateExpiration ? this.formatDateForServer(this.editedItem.dateExpiration, true) : null
      };

      console.log("Données à envoyer:", messageData);

      const url = `${this.$store.getters.user.baseUrl}/wallet/employee_messages/${sender_id}`;

      apiClient
          .post(url, messageData)
          .then(res => {
            this.loading = false;
            if (res.data.status === 200) {
              this.color = "#009688";
              this.text = res.data.message;
              this.dialog = false;
              this.getData();
              this.initEditedItem();
              this.showAlert('info');
            } else {
              this.color = "#F44336";
              this.text = res.data.message;
              this.showAlert('warning');
            }
          })
          .catch(err => {
            console.error("Erreur création:", err.response || err);
            this.text = err.response?.data?.message || err.message || "Erreur lors de la création";
            this.loading = false;
            this.color = "#F44336";
            this.showAlert('warning');
          });
    },

    updateEmployeeMessage() {
      if (!this.FormIsValidModif) {
        return;
      }

      console.log("updateEmployeeMessage - Starting update with:", this.editedItem);

      this.loading = true;
      const sender_id = sessionStorage.getItem("accountId");

      const messageData = {
        companyId: parseInt(sessionStorage.getItem("companyId")) || 1,
        matricule: this.editedItem.matricule,
        identifiantCarte: this.editedItem.identifiantCarte || null,
        message: this.editedItem.message,
        priorite: this.editedItem.priorite.toUpperCase(),
        type: this.editedItem.type || null,
        // ✅ CORRECTION: Formatage avec heures automatiques
        dateActivation: this.editedItem.dateActivation ? this.formatDateForServer(this.editedItem.dateActivation, false) : null,
        dateExpiration: this.editedItem.dateExpiration ? this.formatDateForServer(this.editedItem.dateExpiration, true) : null
      };

      console.log("updateEmployeeMessage - Data to send:", messageData);

      const url = `${this.$store.getters.user.baseUrl}/wallet/employee_messages/${this.editedItem.id}/${sender_id}`;

      apiClient
          .put(url, messageData)
          .then(res => {
            console.log("updateEmployeeMessage - Response:", res.data);

            this.loading = false;
            if (res.data.status === 200) {
              this.color = "#009688";
              this.text = res.data.message;
              this.hide();
              this.getData();
              this.initEditedItem();
              this.showAlertS('info');
            } else {
              this.color = "#F44336";
              this.text = res.data.message;
              this.showAlertS('warning');
            }
          })
          .catch(err => {
            console.error("updateEmployeeMessage - Error:", err);

            this.text = err.response?.data?.message || err.message || "Erreur lors de la modification";
            this.loading = false;
            this.color = "#F44336";
            this.showAlertS('warning');
          });
    },

    activateMessage(row) {
      let rowData = this.$refs.hotTable.hotInstance.getData()[row];
      let messageId = rowData[0];

      if (!messageId || messageId === "") {
        this.color = "#F44336";
        this.text = "Impossible d'activer le message : ID manquant dans les données retournées par l'API";
        this.showAlert('warning');
        return;
      }

      const sender_id = sessionStorage.getItem("accountId");

      let message = {
        title: 'Fenêtre de confirmation',
        body: 'Confirmez l\'activation du message.'
      };

      this.$dialog
          .confirm(message)
          .then(dialog => {
            this.loading = true;

            apiClient
                .patch(`${this.$store.getters.user.baseUrl}/wallet/employee_messages/${messageId}/activate/${sender_id}`)
                .then(res => {
                  dialog.close();
                  this.loading = false;
                  if (res.data.status === 200) {
                    this.color = "#009688";
                    this.text = res.data.message;
                    this.showAlert('info');
                    this.getData();
                  } else {
                    this.color = "#F44336";
                    this.text = res.data.message;
                    this.showAlert('warning');
                  }
                })
                .catch((error) => {
                  dialog.close();
                  this.loading = false;
                  this.color = "#F44336";
                  this.text = error.response?.data?.message || "Erreur lors de l'activation";
                  this.showAlert('warning');
                });
          })
          .catch(() => {
            // User cancelled
          });
    },

    deactivateMessage(row) {
      let rowData = this.$refs.hotTable.hotInstance.getData()[row];
      let messageId = rowData[0];

      if (!messageId || messageId === "") {
        this.color = "#F44336";
        this.text = "Impossible de désactiver le message : ID manquant dans les données retournées par l'API";
        this.showAlert('warning');
        return;
      }

      const sender_id = sessionStorage.getItem("accountId");

      let message = {
        title: 'Fenêtre de confirmation',
        body: 'Confirmez la désactivation du message.'
      };

      this.$dialog
          .confirm(message)
          .then(dialog => {
            this.loading = true;

            apiClient
                .patch(`${this.$store.getters.user.baseUrl}/wallet/employee_messages/${messageId}/deactivate/${sender_id}`)
                .then(res => {
                  dialog.close();
                  this.loading = false;
                  if (res.data.status === 200) {
                    this.color = "#009688";
                    this.text = res.data.message;
                    this.showAlert('info');
                    this.getData();
                  } else {
                    this.color = "#F44336";
                    this.text = res.data.message;
                    this.showAlert('warning');
                  }
                })
                .catch((error) => {
                  dialog.close();
                  this.loading = false;
                  this.color = "#F44336";
                  this.text = error.response?.data?.message || "Erreur lors de la désactivation";
                  this.showAlert('warning');
                });
          })
          .catch(() => {
            // User cancelled
          });
    },

    convertFrenchDateToTimestamp(frenchDate, isExpirationDate = false) {
      if (!frenchDate || typeof frenchDate !== 'string') return null;

      try {
        console.log("convertFrenchDateToTimestamp - Input:", frenchDate, "isExpiration:", isExpirationDate);

        let date;

        // Format DD/MM/YYYY
        if (frenchDate.match(/^\d{2}\/\d{2}\/\d{4}$/)) {
          const parts = frenchDate.split('/');
          const day = parts[0];
          const month = parts[1];
          const year = parts[2];
          date = moment(`${year}-${month}-${day}`, "YYYY-MM-DD");
          console.log("Parsed DD/MM/YYYY:", `${day}/${month}/${year}`, "->", date.format());
        } else {
          moment.locale('fr');
          date = moment(frenchDate);
          console.log("Parsed other format:", frenchDate, "->", date.format());
        }

        if (!date.isValid()) {
          console.error("Date invalide pour timestamp:", frenchDate);
          return null;
        }

        // Ajouter les heures automatiquement
        if (isExpirationDate) {
          date.set({ hour: 23, minute: 59, second: 59, millisecond: 0 });
        } else {
          date.set({ hour: 0, minute: 0, second: 0, millisecond: 0 });
        }

        const result = date.valueOf();
        console.log("convertFrenchDateToTimestamp - Output:", result, "->", date.format("YYYY-MM-DD HH:mm:ss"));
        return result;

      } catch (e) {
        console.error("Erreur conversion date:", e, frenchDate);
        return null;
      }
    },

    afterChangeMe(changes, source) {
      if (changes !== null && source === "edit" && (changes[0][2] !== changes[0][3])) {
        let message = {
          title: 'Fenêtre de confirmation',
          body: 'Confirmez la modification du message employé.'
        };

        this.$dialog
            .confirm(message)
            .then(dialog => {
              this.loading = true;
              let obj = this.$refs.hotTable.hotInstance.getData()[changes[0][0]];
              const sender_id = sessionStorage.getItem("accountId");

              let dateActivation = obj[6];
              let dateExpiration = obj[7];

              // Convertir les dates du format DD/MM/YYYY vers timestamp avec heures
              if (dateActivation && typeof dateActivation === 'string') {
                dateActivation = this.convertFrenchDateToTimestamp(dateActivation, false);
              }
              if (dateExpiration && typeof dateExpiration === 'string') {
                dateExpiration = this.convertFrenchDateToTimestamp(dateExpiration, true);
              }

              const messageData = {
                companyId: parseInt(sessionStorage.getItem("companyId")) || 1,
                matricule: obj[1],
                identifiantCarte: obj[2] || null,
                message: obj[3],
                priorite: obj[4] ? obj[4].toUpperCase() : "MEDIUM",
                type: obj[5] || null,
                // ✅ UTILISER LE NOUVEAU FORMAT AVEC HEURES
                dateActivation: dateActivation ? this.formatDateForServer(dateActivation, false) : null,
                dateExpiration: dateExpiration ? this.formatDateForServer(dateExpiration, true) : null
              };

              const url = `${this.$store.getters.user.baseUrl}/wallet/employee_messages/${obj[0]}/${sender_id}`;

              apiClient
                  .put(url, messageData)
                  .then(res => {
                    dialog.close();
                    this.loading = false;
                    if (res.data.status === 200) {
                      this.color = "#009688";
                      this.text = res.data.message;
                      this.showAlert('info');
                      this.getData();
                    } else {
                      this.color = "#F44336";
                      this.text = res.data.message;

                      let myData = this.$refs.hotTable.hotInstance.getData();
                      myData[changes[0][0]][changes[0][1]] = changes[0][2];
                      this.$refs.hotTable.hotInstance.loadData(myData);

                      this.showAlert('warning');
                    }
                  })
                  .catch((err) => {
                    this.loading = false;
                    dialog.close();

                    let myData = this.$refs.hotTable.hotInstance.getData();
                    myData[changes[0][0]][changes[0][1]] = changes[0][2];
                    this.$refs.hotTable.hotInstance.loadData(myData);

                    this.color = "#F44336";
                    this.text = err.response?.data?.message || err.message || "Erreur lors de la modification";
                    this.showAlert('warning');
                  });
            })
            .catch(() => {
              this.loading = false;
              let myData = this.$refs.hotTable.hotInstance.getData();
              myData[changes[0][0]][changes[0][1]] = changes[0][2];
              this.$refs.hotTable.hotInstance.loadData(myData);
            });
      }
    },

    beforeRemoveRowMe(index, amount) {
      let rowData = this.$refs.hotTable.hotInstance.getData()[index];
      let messageId = rowData[0];

      if (!messageId || messageId === "") {
        this.color = "#F44336";
        this.text = "Impossible de supprimer le message : ID manquant dans les données retournées par l'API";
        this.showAlert('warning');
        return false;
      }

      let message = {
        title: 'Fenêtre de confirmation',
        body: 'Confirmez la suppression du message employé.'
      };

      this.$dialog
          .confirm(message)
          .then(dialog => {
            this.loading = true;
            const sender_id = sessionStorage.getItem("accountId");

            apiClient
                .delete(
                    `${this.$store.getters.user.baseUrl}/wallet/employee_messages/${messageId}/${sender_id}`
                )
                .then(res => {
                  dialog.close();
                  this.loading = false;
                  if (res.data.status === 200) {
                    this.color = "#009688";
                    this.text = res.data.message;
                    this.showAlert('info');
                    this.getData();
                  } else {
                    this.$refs.hotTable.hotInstance.alter("insert_row_above", index);
                    this.$refs.hotTable.hotInstance.populateFromArray(index, 0, [rowData]);

                    this.color = "#F44336";
                    this.text = res.data.message;
                    this.showAlert('warning');
                  }
                })
                .catch((error) => {
                  dialog.close();
                  this.loading = false;

                  this.$refs.hotTable.hotInstance.alter("insert_row_above", index);
                  this.$refs.hotTable.hotInstance.populateFromArray(index, 0, [rowData]);

                  this.color = "#F44336";
                  this.text = error.response?.data?.message || "Erreur lors de la suppression";
                  this.showAlert('warning');
                });
          })
          .catch(() => {
            this.$refs.hotTable.hotInstance.alter("insert_row_above", index);
            this.$refs.hotTable.hotInstance.populateFromArray(index, 0, [rowData]);
          });
    },

    afterLoadData() {
      this.toObject = [this.hotSettings.colHeaders, ...this.$refs.hotTable.hotInstance.getData()];
    },

    afterFilter() {
      this.toObject = [this.hotSettings.colHeaders, ...this.$refs.hotTable.hotInstance.getData()];
    }
  },
};
</script>

<style scoped>
.toolbar .v-toolbar__content {
  padding: 0 !important
}

.v-text-field {
  min-width: 222px;
}

.custom-btn {
  width: 222px;
}

.custom-btn::before {
  color: transparent
}

.custom-btn:hover {
  color: #F5F5F5 !important;
}

.centered-input >>> input {
  text-align: center !important;
}

.centered-input >>> textarea {
  text-align: center !important;
}

.area.highlight,
.htCenter.htMiddle.highlight {
  background-color: #d0e1ef !important;
}

.v-select__selections {
  width: 100% !important;
  display: flex !important;
  justify-content: center !important;
}

.v-select__selection {
  margin: 0 !important;
  text-align: center !important;
}

.v-input--selection-controls__input {
  margin: 0 auto !important;
}

.v-select .v-select__selection--comma {
  margin: 0 auto !important;
  text-align: center !important;
  width: 100% !important;
  overflow: visible !important;
}

.v-select .v-input__slot div {
  text-align: center !important;
}

/* ✅ Styles pour le datepicker */
:deep(.htDatepickerHolder) {
  font-family: 'Roboto', sans-serif;
}

:deep(.htDatepickerHolder .htDatepickerMonth) {
  font-weight: bold;
  font-size: 16px;
}

/* Mettre en évidence la date d'aujourd'hui */
:deep(.htDatepickerHolder .htDatepickerCalendar td.htDatepickerToday) {
  background-color: #2196F3 !important;
  color: white !important;
  font-weight: bold;
}
</style>